export default __webpack_public_path__ + "static/media/DPOS-400.63d9e5f6.png";